import { Email, Phone } from "@mui/icons-material";
import { Box, Button, Divider, TextField, Typography } from "@mui/material";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { setTabIndex } from "../../ReduxStore/UserSlice";
import { useDispatch, useSelector } from "react-redux";
import { subscribeNewsletter } from "../../API/API";
import { showToast } from "../../components/common/Util/Util";

const Footer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;
  const isAuthenticated =
    useSelector((state) => state.user?.user?.jwtToken) ||
    localStorage.getItem("jwtToken");
  const userDetail = useSelector((state) => state.user.user);
  const [email, setEmail] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);

  const isLender =
    userDetail &&
    (userDetail.UserType || userDetail.userType || "").toLowerCase() ===
      "lender";

  const navigationItems = [
    "Home",
    "About Us",
    "How It Works",
    "Careers",
    "Contact Us",
  ]
    .concat(!isLender ? ["Calculator"] : [])
    .concat(["Blog"]) 
    .concat(["Knowledge"]) 
    .concat(["FAQ", "Privacy Policy", "Terms of Service"]);

  const isInDashboardContext = () => {
    return (
      currentPath.includes("/dashboard") ||
      currentPath === "/profile" ||
      currentPath === "/application-history" ||
      currentPath === "/notification-settings" ||
      currentPath === "/apply-loan" ||
      currentPath === "/resume-application" ||
      currentPath === "/accepted-offers" ||
      currentPath.startsWith("/proposal-details") ||
      currentPath === "/calculators"
    );
  };

  const handleTabChange = (tabName) => {
    window.scrollTo(0, 0);

    const isDashboard = isInDashboardContext() && isAuthenticated;

    if (tabName === "Home") {
      navigate("/");
      dispatch(setTabIndex(1));
    } else if (tabName === "About Us") {
      navigate("/about-us");
      dispatch(setTabIndex(4));
    } else if (tabName === "Careers") {
      navigate("/careers");
      dispatch(setTabIndex(5));
    } else if (tabName === "Contact Us") {
      if (isDashboard) {
        navigate("/dashboard/contact-us");
      } else {
        navigate("/contact-us");
      }
      dispatch(setTabIndex(6));
    } else if (tabName === "How It Works") {
      if (isDashboard) {
        navigate("/dashboard/how-it-works");
      } else {
        navigate("/how-it-works");
      }
      dispatch(setTabIndex(2));
    } else if (tabName === "Calculator") {
      if (isDashboard) {
        navigate("/calculators");
      } else {
        navigate("/calculator");
      }
      dispatch(setTabIndex(7));
    } else if (tabName === "Blog") {
      navigate("/blog");
    }else if(tabName=== "Knowledge"){
      navigate("/knowledge");
    }else if(tabName=== "Privacy Policy"){
      navigate("/privacy-policy");
    } else if (tabName === "Terms of Service") {
      navigate("/terms-of-service");
    } else if (tabName === "FAQ") {
      navigate("/faq");
    } else {
      navigate("/");
    }
  };

  const handleSubscribe = async () => {
    const trimmedEmail = (email || "").trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!trimmedEmail || !emailRegex.test(trimmedEmail)) {
      showToast("Please enter a valid email address", "error");
      return;
    }

    const payload = {
      email: trimmedEmail,
      subscribed: true,
    };

    if (isAuthenticated) {
      const name = userDetail?.Name || userDetail?.name;
      const mobileNumber =
        userDetail?.MobileNumber ||
        userDetail?.mobileNumber ||
        userDetail?.Mobile ||
        userDetail?.PhoneNumber ||
        userDetail?.phoneNumber || "";

      if (name) payload.name = name;
      if (mobileNumber) payload.mobileNumber = String(mobileNumber).replace(/-/g, "");
    }

    try {
      setSubmitting(true);
      await subscribeNewsletter(payload);
      showToast("Subscribed successfully", "success");
      setEmail("");
    } catch (e) {
      const message = e?.response?.data?.message || "Subscription failed. Please try again.";
      showToast(message, "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#1E1E1E",
        backgroundSize: "cover",
        color: "white",
        py: 4,
      }}
    >
      <Box sx={{ maxWidth: "1200px", margin: "0 auto", px: { xs: 2, md: 4 } }}>
        {/* Logo and Social Icons */}
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          gap={1}
          mb={3}
        >
          <img src="/logo.png" alt="Logo" style={{ height: 35 }} />
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              height: 40,
              backgroundColor: "white",
              marginLeft: "15px",
              marginRight: "15px",
            }}
          />
          <Box display="flex" gap={3}>
            <img
              src="/flogo.png"
              alt="Facebook"
              style={{ height: 15, cursor: "pointer" }}
            />
            <img
              src="/xLogo.png"
              alt="Twitter"
              style={{ height: 15, cursor: "pointer" }}
              onClick={() =>
                window.open("https://x.com/dequitecfinance", "_blank")
              }
            />
            <img
              src="/linkdinLogo.png"
              alt="LinkedIn"
              style={{ height: 15, cursor: "pointer" }}
              onClick={() =>
                window.open(
                  "https://www.linkedin.com/company/dequitec",
                  "_blank"
                )
              }
            />
            <img
              src="/ilogo.png"
              alt="Instagram"
              style={{ height: 15, cursor: "pointer" }}
            />
          </Box>
        </Box>

        {/* Navigation Links */}
        <Box
          display="flex"
          justifyContent="center"
          gap={3}
          mb={4}
          flexWrap="wrap"
        >
          {/* {navigationItems.map((text) => (
            <Typography 
              key={text}
              sx={{ 
                textAlign: 'center',
                cursor:"pointer", 
                fontSize: '14px',
                position: 'relative'
              }} 
              onClick={() => handleTabChange(text)}
            >
              {text}
            </Typography>
          ))} */}

          {navigationItems.map((text) => {
            const isActive =
              (text === "Home" && currentPath === "/") ||
              (text === "About Us" && currentPath.includes("/about-us")) ||
              (text === "Careers" && currentPath.includes("/careers")) ||
              (text === "Contact Us" && currentPath.includes("/contact-us")) ||
              (text === "How It Works" &&
                currentPath.includes("/how-it-works")) ||
              (text === "Calculator" &&
                (currentPath.includes("/calculator") ||
                  currentPath.includes("/calculators"))) ||
              (text === "Blog" && currentPath.includes("/blog")) ||
              (text === "Privacy Policy" &&
                currentPath.includes("/privacy-policy")) ||
              (text === "Terms of Service" &&
                currentPath.includes("/terms-of-service")) ||
              (text === "FAQ" && currentPath.includes("/faq"));

            return (
              <Typography
                key={text}
                sx={{
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "14px",
                  position: "relative",
                  fontWeight: isActive ? "bold" : "normal",
                  color: isActive ? "#18CB96" : "white",
                  // borderBottom: isActive ? "2px solid #18CB96" : "none",
                  pb: isActive ? 0.5 : 0,
                }}
                onClick={() => handleTabChange(text)}
              >
                {text}
              </Typography>
            );
          })}
        </Box>

        {/* Two-column section */}
        <Box
          display="flex"
          justifyContent="space-between"
          flexWrap="wrap"
          mb={4}
        >
          {/* Contact Info Column */}
          <Box sx={{ width: { xs: "100%", md: "45%" }, mb: { xs: 3, md: 0 } }}>
            <Box display="flex" alignItems="flex-start" gap={2} mb={2}>
              <img
                src="/location.png"
                alt="Location"
                style={{ height: 20, marginTop: 3 }}
              />
              <Box>
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Smyan Tech Solutions Pvt Ltd
                </Typography>
                <Typography variant="body2" sx={{ fontSize: "14px" }}>
                  Plot no. 145, Sector 44, Gurgaon – 122003
                </Typography>
              </Box>
            </Box>
            <Box display="flex" alignItems="center" gap={2} mb={2}>
              <Phone sx={{ fontSize: 20 }} />
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                +91 9220 5899 29
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Email sx={{ fontSize: 20 }} />
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                contact@dequitec.com
              </Typography>
            </Box>
          </Box>

          {/* Newsletter Column */}
          <Box flex={1} maxWidth={600} textAlign="left" mb={3}>
            <Typography variant="h6" mb={2}>
              Stay Updated with the Latest Funding Insights!
            </Typography>
            <Typography variant="subtitle2" fontStyle="italic" mb={3}>
              Subscribe to our newsletter for expert tips, funding
              opportunities, and exclusive updates —delivered straight to your
              inbox!
            </Typography>
            <Box display="flex" gap={2} flexWrap="nowrap">
              <TextField
                placeholder="Enter your email"
                variant="outlined"
                fullWidth
                sx={{
                  bgcolor: "#333333",
                  borderRadius: 1,
                  height: 55,
                  input: { color: "white", fontStyle: "italic" },
                  border: "none",
                  "& fieldset": { border: "none" },
                }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#18CB96",
                  color: "white",
                  height: 55,
                  px: 3,
                  whiteSpace: "nowrap",
                  textTransform: "none",
                  minWidth: "fit-content",
                }}
                disabled={submitting}
                onClick={handleSubscribe}
              >
                {submitting ? "Submitting..." : "Get Updates"}
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Divider */}
        <Divider sx={{ backgroundColor: "rgba(255,255,255,0.2)", mb: 2 }} />

        {/* Copyright */}
        <Typography
          textAlign="center"
          sx={{ fontSize: { xs: "12px", sm: "14px", md: "16px" } }}
        >
          © {new Date().getFullYear()} Smyan Tech Solutions Pvt Ltd. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
